import React, {useState} from 'react';
import JobService from '../../services/JobService';

const CreateFollowOnButton = (props) => {
    const {job, disabled, nextFollowOnPageRoute, showLink} = props;
    const buttonText = props.buttonText || 'Create follow on job';
    const [jobService] = useState(new JobService());
    const [loading, setLoading] = useState(false);

    async function submit(evt) {
        evt.preventDefault();
        try {
            setLoading(true);
            const response = await jobService.createFollowOn(job.id);
            toastr.success('Created follow on job');
            setLoading(false);
            window.open(`/jobs/${response.data.id}`, '_blank');
        } catch (e) {
            toastr.error(e.response.data?.message ?? 'Something went wrong');
            setLoading(false);
        }
    }

    return (
        !nextFollowOnPageRoute ?
            <button
                onClick={submit}
                type="button"
                className="btn btn-cw-green ml-3"
                style={{ width: 200, marginTop: 20, marginLeft: 15, float: 'right' }}
                disabled={loading === true || disabled}
            >
                {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
                {!loading && buttonText}
            </button> :
            showLink ? <a
                href={nextFollowOnPageRoute}
                style={{ width: 200, marginTop: 20, marginLeft: 15, float: 'right', padding: '0.375rem 0.75rem', textAlign: 'right'}}
            >Next Follow On Job</a>  : <React.Fragment />
    );
};

export default CreateFollowOnButton;
